import Link from "next/link";
import { BrickWall } from "lucide-react";
import { Button } from "../shadcn/button";
import { usePermissions } from "@/hooks/usePermissions";
import { ORG_PERMISSIONS } from "@/constants/permissions";

// Its own component so usePermissions, which fetches, only runs in the
// platform chat and never in a deployed widget.
export const ManageUsageControlsButton = ({ label }: { label: string }) => {
  const { hasPermission } = usePermissions();
  if (!hasPermission(ORG_PERMISSIONS.ORG.BILLING, "tenant")) return null;
  return (
    <Button variant="ghostDestructive" className="px-0" asChild>
      <Link href="/settings/administration/billing?tab=limits">
        <BrickWall className="size-4" />
        {label}
      </Link>
    </Button>
  );
};
